<template>
  <div class="liu">
    <!-- 标题 -->
    <mt-header fixed title="任务统计明细" class="title2">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight">
      <!-- 信息列表 -->
      <div class="achi-info detail-list">
        <div class="box-item" v-for="(item, index) in myData.list" :key="index">
          <div class="item-img">
            <svg-icon :icon-class="svgPath" class-name="cur-icon"></svg-icon>
          </div>
          <div class="item-content">
            <span>{{ item.detail }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { GetUserTaskExpiredList } from '@/api/reward';
import { CusToast } from '@/utils/CustomToast';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';

export default {
  name: 'TaskCollectDetail',
  data() {
    return {
      // 标题
      title: '',
      // svg路径
      svgPath: 'member',
      // 数据
      myData: {
        list: [],
      },
      // 查询
      myParam: {
        agentFindType: 0,
        endDate: '',
        productAgentId: '',
        startDate: '',
      },
    };
  },
  mounted() {
    this.initParam();
    this.initData();
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 加载参数
    initParam() {
      this.myParam.agentFindType = this.$route.query.type;
      this.myParam.endDate = `${this.$route.query.date} 23:59:59`;
      this.myParam.productAgentId = this.$route.query.agentid;
      this.myParam.startDate = `${this.$route.query.date} 00:00:00`;
    },
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myData.list = [];
      // 加载数据
      this.getMyData();
    },
    // 通过接口获取数据
    getMyData() {
      Indicator.open();
      GetUserTaskExpiredList(this.myParam)
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myData.list = res.rows;
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          this.myData.list = [];
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
  },
};
</script>
